// @flow
import invariant from 'invariant';

const insertScript = onLoaded => {
  const recaptchaScript = document.createElement('script');
  window.recaptchaOnloadCallback = onLoaded;

  recaptchaScript.setAttribute(
    'src',
    `//www.google.com/recaptcha/api.js?onload=recaptchaOnloadCallback&` +
      `render=explicit&hl=${USER_LOCALE}`
  );

  recaptchaScript.setAttribute('async', 'async');
  recaptchaScript.setAttribute('defer', 'defer');

  invariant(document.head, 'Missing document.head');
  document.head.appendChild(recaptchaScript);
};

let loadingPromise;

export const resetRecaptcha = () =>
  window && window.grecaptcha && window.grecaptcha.reset();

export default () => {
  if (!loadingPromise) {
    loadingPromise = (new Promise(resolve => {
      insertScript(() => {
        resolve(grecaptcha);
      });
    }): Promise<any>);
  }
  return loadingPromise;
};
